import React from 'react'
import {Box} from '@chakra-ui/react'

const FullBleed = props => (
    <Box display="flex" flexDirection="column" alignItems="center" {...props} />
)

export { FullBleed }